import React from 'react'
import { cn } from '@/lib/utils'

export const Pagination: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className, children, ...props }) => (
  <nav {...props}>
    <ul className={cn('flex items-center gap-1', className)}>{children}</ul>
  </nav>
)

interface PaginationItemProps extends React.HTMLAttributes<HTMLLIElement> {
  active?: boolean
  disabled?: boolean
}

export const PaginationItem: React.FC<PaginationItemProps> = ({ active, disabled, className, ...props }) => (
  <li className={cn(disabled && 'opacity-50 pointer-events-none', className)} {...props} />
)

interface PaginationLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  first?: boolean
  previous?: boolean
  next?: boolean
  last?: boolean
  tag?: React.ElementType
}

export const PaginationLink: React.FC<PaginationLinkProps> = ({
  first, previous, next, last, className, children, tag: Tag = 'a', ...props
}) => (
  <Tag
    className={cn(
      'inline-flex items-center justify-center h-8 min-w-8 px-2 rounded-md text-sm border border-border hover:bg-muted cursor-pointer',
      className,
    )}
    {...props}
  >
    {first ? '\u00AB' : previous ? '\u2039' : next ? '\u203A' : last ? '\u00BB' : children}
  </Tag>
)
